/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignOut/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SignOut({
  children,
  viewPath = "/App/Auth/SignOut"
  
}) {
  return null
}